import React from 'react'
import PropTypes from 'prop-types'
import HrbTranslate from '../../language/HrbTranslate';
import Skeleton from '../loaders/Skeleton';

const VerticalNameChildren = props => 
    <div>
        <span><HrbTranslate text={props.textKey} className={props.labelClassName} /></span><br />
        {!props.loading && props.children &&
            props.children
        }
        {props.loading &&
            <Skeleton />
        }
    </div>

VerticalNameChildren.propTypes = {
    textKey: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    labelClassName: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,    
}

export default VerticalNameChildren